import { BoldVerticalBarChartData } from './bold-vertical-bar-chart/BoldVerticalBarChart';

export const formatBoldVerticalChartData = <T>(
	standard: T,
	defaultData: Pick<BoldVerticalBarChartData, 'label'>,
	advancedData: BoldVerticalBarChartData,
) => {
	let data: BoldVerticalBarChartData = { ...defaultData };
	switch (standard) {
		case undefined:
			data = { ...data, isUnmeasurable: true };
			break;
		case 0:
			data = { ...data, isUnmeasurable: true };
			break;
		case false:
			data = { ...data, isUnmeasurable: true };
			break;
		default:
			data = { ...data, ...advancedData };
			break;
	}

	return data;
};
